import * as React from "react";
const SVGComponent = (props) => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x={0}
    y={0}
    width="40%"
    height="50%"
    viewBox="0 0 600 415.09"
    xmlSpace="preserve"
    {...props}
  >
    <style>
      {
        '.st4{fill:#696969}.st5{stroke:#696969;stroke-width:2;stroke-miterlimit:10}.st17,.st5{fill:#fff}.st18{font-family:"LeagueSpartan-Bold"}.st19{font-size:6.7203px}.st20{fill:none;stroke:#696969;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10}.st22{opacity:.21}.st23{fill:#6f9099}.st24{fill:none;stroke:#212c2e;stroke-width:.6927;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.st25{fill:#212c2e}'
      }
    </style>
    <switch>
      <foreignObject
        requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"
        x={0}
        y={0}
        width={1}
        height={1}
      />
      <g>
        <path
          d="M422.84 410.26H197.18c-8.9 0-16.12-7.22-16.12-16.12V212.56c0-8.9 7.22-16.12 16.12-16.12h225.66c8.9 0 16.12 7.22 16.12 16.12v181.58c0 8.9-7.22 16.12-16.12 16.12"
          style={{
            fill: "#ffced8",
          }}
        />
        <path
          d="M202.22 410.26h-15.99a5.16 5.16 0 0 1-5.16-5.16V200.55a5.16 5.16 0 0 1 5.16-5.16h21.15V405.1a5.16 5.16 0 0 1-5.16 5.16"
          style={{
            fill: "#ff9db0",
          }}
        />
        <path
          style={{
            fill: "none",
            stroke: "#fff",
            strokeWidth: 3,
            strokeMiterlimit: 10,
          }}
          d="M307.85 196.45v213.81"
        />
        <path
          d="M421.2 410.26H198.83c-6.9 0-12.5-5.6-12.5-12.5V208.95c0-6.9 5.6-12.5 12.5-12.5H421.2c6.9 0 12.5 5.6 12.5 12.5v188.82c0 6.89-5.6 12.49-12.5 12.49zM310.01 196.45v213.81m-217.04.27h434.09"
          style={{
            fill: "none",
            stroke: "#696969",
            strokeWidth: 2,
            strokeMiterlimit: 10,
          }}
        />
        <path
          className="st4"
          d="M322.09 311.22a3.91 3.91 0 0 1-3.91-3.91V281a3.91 3.91 0 1 1 7.82 0v26.3c0 2.17-1.75 3.92-3.91 3.92m-28.48 0a3.91 3.91 0 0 1-3.91-3.91V281a3.91 3.91 0 1 1 7.82 0v26.3c0 2.17-1.75 3.92-3.91 3.92"
        />
        <circle className="st5" cx={246.24} cy={251.98} r={28.96} />
        <circle className="st5" cx={372.24} cy={251.98} r={28.96} />
        <path
          d="M152.65 294.64s150.81 110.68 318.26 0"
          style={{
            fill: "none",
            stroke: "#ee374d",
            strokeWidth: 5.1459,
            strokeLinecap: "round",
            strokeMiterlimit: 10,
          }}
        />
        <path
          className="st4"
          d="M481.07 409.68h-12.52V299.93c0-3.36 2.72-6.08 6.08-6.08h.36c3.36 0 6.08 2.72 6.08 6.08z"
        />
        <circle className="st4" cx={474.81} cy={286.29} r={8.35} />
        <path
          className="st4"
          d="M484.2 409.68h-18.78c-2.81 0-5.09-2.28-5.09-5.09s2.28-5.09 5.09-5.09h18.78c2.81 0 5.09 2.28 5.09 5.09s-2.28 5.09-5.09 5.09m-328.75 0h-12.52V299.93c0-3.36 2.72-6.08 6.08-6.08h.36c3.36 0 6.08 2.72 6.08 6.08z"
        />
        <circle className="st4" cx={149.19} cy={286.29} r={8.35} />
        <path
          className="st4"
          d="M158.58 409.68H139.8c-2.81 0-5.09-2.28-5.09-5.09s2.28-5.09 5.09-5.09h18.78c2.81 0 5.09 2.28 5.09 5.09-.01 2.81-2.28 5.09-5.09 5.09"
        />
        <image
          style={{
            overflow: "visible",
            opacity: 0.39,
          }}
          width={27}
          height={27}
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhCAYAAABX5MJvAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAvdJREFUeNrsV9tu00AU9NqJE5w2 pRfaAgLKVfwBD/0mHuEj4JFvggd+gatEBCq90CbQJE5sc7aaRcOya2+AB5BqaeTE9u4Znzk7Zx1F 58c/dKhFHn708HHjM0+fPfn7JKzAKmBMBQQTUgEEzDMxQREqCl4SzsiEEFEBBDQSQUuQCtr4HdN4 HbQQzAW5YIbfZQgRFUBAB+wIMsES0CUiFQjo4KeCr4JvgjHIFE1EVAABHbAvWBds4rwMYglIzBD0 i2AfOAaZvIlIYl/YfbBr9E9A4KJgW3BTcE9wX3AX/28IrgmuCDZANsVUBUuioed+8fL5LyRanizE 0F6n/pJgBwTuCK6CWJcykeOt94mIopViijWiQnaTIIn05BcQ7LLgFkjo8xbkSKkm9BtPQKCL6yVk mlJtzF1yxA4CMcjpQlzDm+tMXKe0r4DIEs4reHYL8twGYT12lQvZZXgthykpSGFIbCMbmwiW4X5s GZRZsiXe/kTwWfBJcAi5IstbnHJwPWSQYwNk+pCobXmE7aQZnl0l0qljjFcOrgnjDTrdPVqSvslY yg4k6IJ08jskYprQOGTied7VW5TD5r1HXNOAeHnx/5DmVWIlzLEqyrqxvjczk0yx9CZYZnWTcfAc Djomx/SOjT0EjA0PYcVD9IWcXNBFYAbCI6wOY93TOhI/bFvbKSzb6JliNSxTcaYYoxzt2zQwTfqj 4J3grWCAa5pcIf2j0TErckA94REmXAOJBAF7llcYxzyBL3wA9pDFqWlirky0aurBkBggIy1MdAr/ yKzeoSU4QPBXgvcgMcL90leYP3VRSxKu9IL6wAT1YnQ/RLABJHgteAMyB9hfnJFwSeHLBO+UxshG aaV7HX2jTfeOEXQPOIIUtVkI2VkltLHpwYb7KFTTlLiVD0F0RMtzjg1N9Sd7TLPBSYEOEUiokHPI NaV9ZtlEYJHdNttw4ugFJUlY8CamiUDwx49FRnnGVtY3RxUFHgt9gTm+Reyvryo6P/7347sAAwC3 hStCKFGjtQAAAABJRU5ErkJggg=="
          transform="matrix(.24 0 0 .24 307.596 215.676)"
        />
        <circle
          cx={310.29}
          cy={218.5}
          r={1.82}
          style={{
            fill: "#1f1f1f",
          }}
        />
        <path
          style={{
            fill: "none",
            stroke: "#1f1f1f",
            strokeWidth: 0.7135,
            strokeMiterlimit: 10,
          }}
          d="m293.82 231.9 16.44-13.4 15.95 13.71"
        />
        <image
          style={{
            overflow: "visible",
            opacity: 0.39,
          }}
          width={193}
          height={129}
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAACBCAYAAACFD/U6AAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABCRJREFUeNrs2U2PU1UYwPF2+jLq KCNGGTN1ISZGNq79VCzhQ8CSD0YMGwIGQxxggsTADAVmptPhOfrccK19jZve8vslT0o7tIvm/nvO adutFdy4frPctPPu5C2sq4vJ29t3bi31xPaKYZTpxHRztmqPw7rGUWYcM8o5rx5fFEp7hTBKEP2Y z2K+iPk8ZrsWCaxrICWOk5jXMccxb/J+CWU8L5L2EnF0MoSdmK9i9mL2Y65kJF2BsOaBjDKO5zFP Y57FvIgZxpzNi2ReIFUcZcX4OmYQ833MD3n7bUYjEJoQSInhMOZRzIOYhzEHMUcxp7Miac9ZPcrW 6dNcMX6K+TnmWszVfGzXFouGbbFexTyJuR9zN+ZezON8fOpK0p2z9ermFmqQcfwS82NurXbyPNIR Bw2J5DzPzpfyuu7n36qD+3HtQD87kNrZo7zA5dxOXcs4vpvYVomDptjK67aXH+wlhHcxL3PeZij/ edK01aM6e+zlmaNsq77JOHq2VTRQO6/bfh4P9vO6HuSqMvUsvTXjxbr5pOpgvtfyjRWbs5L08sN+ N6/z7VwUWsuuINX540rtQN4XBxsUSSdDmfuD96wVpJNB7LQ+/CDoQM6mbbnai87SW3OeWB1qus4c fMxLzf8qDD7WQEAg3gIQCAgEBAICAYGAQEAgIBAQCCAQEAgIBAQCAgGBgEBAICAQEAggEBAICAQE AgIBgYBAQCAgEEAgIBAQCAgEBAICAYGAQEAgIBBAICAQEAgIBAQCAgGBgEBAIIBAQCAgEBAICAQE AgIBgYBAQCCAQEAgIBAQCAgEBAICAYGAQACBgEBAICAQEAgIBAQCAgGBgEAAgYBAQCAgEBAICAQE AgIBgYBAvAUgEBAICAQEAgIBgYBAQCAgEEAgIBAQCAgE1jCQi4kBgdSCGMeMcsYiQSAfnMecxgxz TvMxkbApltohzVpBSgyvY17E/Jn/HnlP2aA4pu2QLpZdQUa5cjyPOYx5mavI2HvLBsRRFoCT/OCv 75BWWkHexvyVgZRV5DjmTCRsQCAn+aF/mItAtUNavILcvnOrepHTDORxzG8xBzGvREKDjfO6Pop5 GvN7zJO8P/UI0Z1T2VlW9ihmN+aTmE7+rdzvtfyOQrPiOMsP+T9i7sc8iHkW86Y140uo7oJ92jAL q8dQHt+P2clg2t57GnLuGObKcS/mbszD1j9fRJUt10XunhYHUv7jjes3q+KOcptVVfgu5mrMl/l8 gdCEQEa5Iyrbql8zkoOMZuZPGHMv7oikOqf0Yy7FDDKOQd4XCE0K5Ch3RPWzx9/fzk5bPVrLXNy1 SHq5rdrNOLbzcYHQhEDGuZU6ynPIMHdIM+NoLXtx1yLp5KrRrcUhEJoQyOSPg+eL4mitcnFnJO2J 54mDJkXyr9tFcRTvBRgAroEEhzNHauUAAAAASUVORK5CYII="
          transform="matrix(.24 0 0 .24 287.864 230.024)"
        />
        <path
          d="M314.36 238.65c.92 0 .92-1.43 0-1.43s-.92 1.43 0 1.43"
          style={{
            fill: "#f7f7f7",
          }}
        />
        <path
          d="M289.65 258.91c-.64 0-1.16-.52-1.16-1.16v-25.22c0-.64.52-1.16 1.16-1.16h40.72c.64 0 1.16.52 1.16 1.16v25.22c0 .64-.52 1.16-1.16 1.16z"
          style={{
            fill: "#a72740",
          }}
        />
        <linearGradient
          id="SVGID_1_"
          gradientUnits="userSpaceOnUse"
          x1={287.925}
          y1={245.14}
          x2={332.099}
          y2={245.14}
        >
          <stop
            offset={0.006}
            style={{
              stopColor: "#303030",
            }}
          />
          <stop
            offset={1}
            style={{
              stopColor: "#1b1b1b",
            }}
          />
        </linearGradient>
        <path
          d="M330.37 231.94c.32 0 .59.26.59.59v25.22c0 .32-.26.59-.59.59h-40.72c-.32 0-.59-.26-.59-.59v-25.22c0-.32.26-.59.59-.59zm0-1.14h-40.72c-.95 0-1.73.78-1.73 1.73v25.22c0 .95.78 1.73 1.73 1.73h40.72c.95 0 1.73-.78 1.73-1.73v-25.22c0-.95-.78-1.73-1.73-1.73"
          style={{
            fill: "url(#SVGID_1_)",
          }}
        />
        <g
          style={{
            opacity: 0.31,
          }}
        >
          <image
            style={{
              overflow: "visible",
            }}
            width={480}
            height={417}
            xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAeMAAAGlCAYAAADJdp5JAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABbpJREFUeNrs2z9rGnEYwPHcGVw0 UOhS1ELiGOdMfTd9H06+go5d+m46ZSsY6GShKARH42DAs88TzBKydDi5k88HfuTP+PDjvvfzzosL AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAoAaF EXAqk8mku91uB2VZdk2DJquq6rnX663m8/mzaSDGnFWED4fDTfw5jTU0FRpuGWtWFMVClBFjziLE m83mLi5qs/gzYzyI5WRM02V8V7EWcRM5vbq6uhdk6tQxAuoUp4rP8eNbrC+xPtpztOja+CHWMG4k b3e73cNoNHpcr9d7o6EOpRFQ56n4+NH0jdMwLZX79uWTnXzUYhyIMa1zvHjlM2IXMdoe5Ju8scwb TOOgDpdGQG13emXZ3e/3w3dOxa/P4zyDo6nxfftuw8uNZdxgfo2ff4wIMabtMsD3eWHrdDpL46Bp 4gR8XVXV9/j1+k2gh76WhxhzLvJEPO33+z+9nUoTjcfj15tGOBnPjDn5yThPxEIMIMYAIMYAgBgD gBgDAGIMAGIMAGIMAIgxAIgxACDGACDGAIAYA4AYAwBiDABiDACIMQCIMQAgxgAgxgCAGAOAGAMA YgwAYgwAiDEAiDEAIMYAIMYAgBgDgBgDAGIMAGIMAIgxAIgxACDGACDGAIAYA4AYAwBiDABiDACI MQCIMQAgxgAgxgCAGAOAGAMAYgwAYgwAiDEAiDEAIMYAIMYAgBgDgBgDAGIMAGIMAIgxAIgxACDG ACDGAIAYA4AYAwBiDABiDACIMQCIMQAgxgAgxgCAGAOAGAMAYgwAYgwAYgwAiDEAiDEAIMYAIMYA gBgDgBgDAGIMAGIMAIgxAIgxACDGACDGAIAYA4AYAwBiDABiDACIMQCIMQAgxgAgxgCAGAOAGAMA YgwAYgwAiDEAiDEAIMYAIMYAgBgDgBjDf+vu9/vhZDLpGgVNk/sy92fuU9PglC6NgBMbxJo9PT1N x+Px0jhoktiXGeLZcZ+CGHO+J+NYd7F+xAnk2Tho4P4cvHMyzr26rKrKnkWMaZfjhStPv9dvLm7d 4/+gLVZ5Yu71eiujoA6eGVObvHAdDodp/Hp/PFlAG+XeXRRFsZjP5/YxtegYAXVZr9f70Wj0uNvt HuJCdhv/+mTP0bII/431K28q+/3+79zTxkIdCiOgbvmG6mazuYsg54sxQxOhJfIRyyxPxPkpj1Mx YsxZBHm73Q7KsvSVEVoh33kQYQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAIBW+yfAAEZCvm1iSxuOAAAAAElFTkSuQmCC"
            transform="matrix(.24 0 0 .24 252.48 195.36)"
          />
        </g>
        <path
          d="M326.78 234.26c0 .3-.24.54-.54.54s-.54-.24-.54-.54.24-.54.54-.54c.3-.01.54.24.54.54"
          style={{
            fill: "#c40602",
          }}
        />
        <linearGradient
          id="SVGID_00000003072960747293721660000008114287104674738332_"
          gradientUnits="userSpaceOnUse"
          x1={325.419}
          y1={234.12}
          x2={326.504}
          y2={234.12}
        >
          <stop
            offset={0.006}
            style={{
              stopColor: "#fff",
            }}
          />
          <stop
            offset={0.848}
            style={{
              stopColor: "#e7ebec",
            }}
          />
        </linearGradient>
        <path
          style={{
            fill: "url(#SVGID_00000003072960747293721660000008114287104674738332_)",
          }}
          d="M326.5 234.12c0 .3-.24.54-.54.54s-.54-.24-.54-.54.24-.54.54-.54.54.24.54.54"
        />
        <circle
          cx={293.98}
          cy={234.26}
          r={0.54}
          style={{
            fill: "#dc0902",
          }}
        />
        <linearGradient
          id="SVGID_00000176042995458189590100000002302725516818232448_"
          gradientUnits="userSpaceOnUse"
          x1={293.242}
          y1={234.12}
          x2={294.328}
          y2={234.12}
        >
          <stop
            offset={0.006}
            style={{
              stopColor: "#fff",
            }}
          />
          <stop
            offset={0.848}
            style={{
              stopColor: "#e7ebec",
            }}
          />
        </linearGradient>
        <path
          style={{
            fill: "url(#SVGID_00000176042995458189590100000002302725516818232448_)",
          }}
          d="M294.33 234.12c0 .3-.24.54-.54.54s-.54-.24-.54-.54.24-.54.54-.54.54.24.54.54"
        />
        <text
          transform="matrix(.9584 0 0 1 296.485 241.954)"
          className="st17 st18 st19"
        >
          {"ACCESS"}
        </text>
        <text
          transform="matrix(.9584 0 0 1 297.824 251.787)"
          className="st17 st18 st19"
        >
          {"DENIED"}
        </text>
        <path
          className="st17"
          d="M324.46 256.45h-27.7a.28.28 0 0 1-.28-.28v-.11c0-.15.12-.28.28-.28h27.7c.15 0 .28.12.28.28v.11c-.01.16-.13.28-.28.28m-29.5-1.34c0 .39-.31.7-.7.7s-.7-.31-.7-.7.31-.7.7-.7.7.31.7.7m32.52 0c0 .39-.31.7-.7.7s-.7-.31-.7-.7.31-.7.7-.7.7.31.7.7"
        />
        <path className="st20" d="M349.05 256.61s-5.22-12.09 8.87-24" />
        <circle className="st20" cx={351.11} cy={259.48} r={0.26} />
        <path className="st20" d="M222.91 257.1s-5.22-12.09 8.87-24" />
        <circle className="st20" cx={224.97} cy={259.97} r={0.26} />
        <path
          d="M433.7 182.7v-14.12m14.46 28.06h14.12m-20.8-8.26 15.5-14.09"
          style={{
            fill: "none",
            strokeLinecap: "round",
            strokeMiterlimit: 10,
            stroke: "#ffd62c",
            strokeWidth: 7,
          }}
        />
        <g className="st22">
          <path
            className="st23"
            d="M335.71 80.43c-.78 1.22-2.46.14-3.24 1.36s.89 2.29.1 3.51c-.78 1.22-2.46.14-3.24 1.36s.89 2.29.1 3.51c-.31.48-.76.61-1.24.66-.53.05-.73.75-.28 1.04l.01.01 3.11 2 8.7-13.53-3.11-2-.01-.01c-.45-.29-1 .18-.83.68.17.46.24.93-.07 1.41"
          />
          <path
            className="st24"
            d="m336.64 78.35 3.11 2-8.7 13.53-3.11-2c-3.74-2.4-4.82-7.38-2.41-11.12h0c2.39-3.73 7.37-4.81 11.11-2.41"
          />
          <path
            className="st23"
            d="M296.28 68.73c.31-.97 1.64-.55 1.95-1.52s-1.02-1.4-.72-2.37c.31-.97 1.64-.55 1.95-1.52s-1.03-1.4-.72-2.37c.12-.38.4-.55.72-.67.35-.14.36-.64 0-.76h-.01l-2.48-.79-3.43 10.8 2.48.79h.01c.36.11.65-.3.44-.62-.18-.28-.31-.58-.19-.97"
          />
          <path
            className="st24"
            d="m296.03 70.32-2.48-.79 3.43-10.8 2.48.79c2.98.95 4.63 4.13 3.68 7.12h0a5.655 5.655 0 0 1-7.11 3.68"
          />
          <path
            className="st24"
            d="M324.04 84.87c-3.75-.42-4.85-4.67-4.92-7.73-.05-2.03 0-4.11-.61-6.05-.53-1.7-1.98-3.98-3.95-4.13-1.04-.08-2.01.5-2.9 1.03-1.98 1.17-5.42 3.41-7.84 2.49-.84-.32-1.48-1.08-2.35-1.32"
          />
          <path
            className="st24"
            d="M324.87 81.21c-3.75-.42-3.99-4.17-4.06-7.23-.05-2.03 0-4.11-.61-6.05-.53-1.7-1.98-3.98-3.95-4.13-1.04-.08-2.01.5-2.9 1.03-1.98 1.17-5.42 3.41-7.84 2.49-.84-.32-1.48-1.08-2.35-1.32"
          />
          <path
            className="st24"
            d="M326.68 78.63c-4.02-.38-4.35-4.39-4.49-7.67-.09-2.18-.08-4.4-.77-6.46-.6-1.81-2.19-4.23-4.31-4.35-1.12-.06-2.14.58-3.09 1.16-2.1 1.29-5.75 3.75-8.35 2.81-.91-.33-1.6-1.12-2.54-1.37"
          />
        </g>
        <g className="st22">
          <path
            className="st23"
            d="M54.68 321.9c-1.04-.7-1.92-1.93-4.43-8.43-2.69-6.97-5.94-3.9-5.94-3.9l-1.06.69-1.14.54s-4.31 1.16.23 7.1c4.23 5.53 4.83 6.93 4.88 8.18.06 1.25 1.53 6.95 4.43 6.4 1.4-.27 2.51-.7 3.38-1.21.89-.47 1.84-1.19 2.8-2.25 1.98-2.19-2.11-6.42-3.15-7.12"
          />
          <path
            className="st25"
            d="M46.33 307c-.97-.39-2.37.62-3.04 1.17l-.26-.47-1.82 1.02.82 1.46.36-.2.2.36-2.63 1.47c-.36.2-.49.66-.29 1.02l.45.8 7.65-4.29-.45-.8a.6.6 0 0 0-.16-.19c-.1-.71-.38-1.17-.83-1.35m-2.64 2.74-.2-.36.36-.2-.35-.62c.68-.57 1.95-1.45 2.67-1.16.26.1.44.37.54.78a.73.73 0 0 0-.4.09zM47 322.48c-1.62-2.89-3.66-4.88-4.75-4.7l.09.12c4.23 5.53 4.83 6.93 4.88 8.18.02.53.3 1.84.83 3.15.1-.01.2-.03.29-.08 1.01-.57.41-3.55-1.34-6.67m4.37-2.45c1.75 3.12 3.98 5.19 4.99 4.62.2-.11.34-.33.41-.63-.8-1.03-1.68-1.85-2.09-2.13-1.04-.7-1.92-1.93-4.43-8.43a1 1 0 0 0-.07-.16c-.06.02-.11.03-.16.06-1 .57-.4 3.55 1.35 6.67"
          />
        </g>
        <g className="st22">
          <path
            className="st23"
            d="M572.04 232.33c-2.11-1.66-4.92-2.3-7.74-1.76-2.57.49-4.87 1.76-6.9 3.8-2.85.12-6.28.79-10.27 2.05-14.65 4.61-25.31 35.86-25.76 37.19a.77.77 0 1 0 1.46.5c.11-.32 10.85-31.83 24.76-36.21 3.19-1 5.98-1.63 8.36-1.89-.48.61-.94 1.27-1.39 1.98l-.03.01c-4.02 1.21-7.94 9.1-7.99 15.9-1.57-.51-3.08-.62-4.51.18-3.24 1.82-8.62 6.28-8.16 15.74.35 7.36-.95 10.48-.96 10.5-.17.39 0 .84.39 1.02.11.05.23.07.35.06.28-.01.55-.18.67-.46.06-.14 1.46-3.41 1.09-11.2-.41-8.63 4.45-12.68 7.38-14.32 1.11-.62 2.39-.42 3.83.13.46 5.16 3.29 8.61 8.05 9.77 3.34.81 6.11.33 8.23-1.42.14-.12.28-.24.42-.37.77-.16 1.49-.39 2.14-.67 4.39-1.89 6.1-9.83 6.29-16.33 1.94-4.16 3.08-8.08 3.01-9.53-.09-1.65-1.1-3.39-2.72-4.67m-13.95 3.55c1.07-.01 2.04.08 2.9.26-1.34.32-2.71.72-4.06 1.13.37-.5.76-.96 1.16-1.39m-2.51 3.41.64-.19c2.48-.76 5.1-1.56 7.38-1.9.02.02.05.03.07.05 1.53 1.06 2.36 2.81 2.47 5.19.11 2.35.32 6.77-.25 11.01-1.74 2.18-3.69 3.83-5.72 4.34-3.31.83-6.33-.44-9.04-1.78-.4-1.74-.3-3.78.3-6.07 1.11-4.32 2.5-7.87 4.15-10.65m-7.48 15.19c-.14-5.29 2.33-11.11 4.95-13.72-1.21 2.49-2.25 5.41-3.13 8.78-.57 2.19-.69 4.04-.52 5.6-.44-.22-.87-.43-1.3-.62zm6.93 9.35c-4.63-1.13-6.29-4.43-6.77-7.54.39.19.79.4 1.2.6.11.06.22.11.33.17a8.83 8.83 0 0 0 2.72 4.15c2.05 1.76 4.76 2.55 7.38 2.63-1.38.45-2.99.45-4.86-.01m7.53-1.72c-3 .52-6.65-.02-9.04-2.07a7.4 7.4 0 0 1-1.61-1.96c2.57 1.15 5.41 2 8.62 1.19 1.7-.42 3.32-1.53 4.83-3.03-.55 2.32-1.43 4.42-2.8 5.87m2.45-.73c1.24-2.09 1.95-4.73 2.34-7.42.95-1.24 1.84-2.62 2.64-4.03-.58 5.04-2.14 10.06-4.98 11.45m5.25-15.16a43 43 0 0 1-2.58 4.7c.24-3.44.09-6.65 0-8.56-.11-2.23-.76-4.01-1.94-5.33 1.81.02 3.19.56 3.75 2.02.56 1.45.84 4.14.77 7.17m.66-7.73c-.94-2.42-3.11-3.12-5.82-2.99-.38.02-.77.05-1.17.1-1.16-.65-2.59-1.04-4.28-1.18 1.51-1.21 3.16-1.99 4.94-2.33 2.37-.45 4.74.08 6.49 1.46 1.27 1 2.07 2.33 2.13 3.54.05.96-.52 3.17-1.53 5.81-.12-1.9-.39-3.46-.76-4.41"
          />
          <path
            className="st25"
            d="m525.05 274.06-5.66-3.29a.355.355 0 0 0-.47.09l-12.36 15.88a3.61 3.61 0 0 0 1.39 5.51c1.49.66 3.28.23 4.3-1.08l12.9-16.58c.06-.08.09-.19.07-.29a.4.4 0 0 0-.17-.24"
          />
          <path
            className="st23"
            d="m515.89 274.76-8.71 11.19 6 4.03 8.72-11.19z"
          />
          <path
            className="st25"
            d="m537.47 280.16-6.35-1.58c-.19-.04-.36.05-.42.22l-7.44 18.7c-.38.97-.33 2.05.14 2.98s1.33 1.6 2.33 1.85c.13.03.26.06.39.07 1.62.22 3.22-.7 3.83-2.24l7.76-19.52c.04-.1.03-.21-.01-.3a.42.42 0 0 0-.23-.18"
          />
          <path
            className="st23"
            d="m528.87 283.38-5.25 13.19 6.89 2.19 5.24-13.18z"
          />
        </g>
        <g className="st22">
          <path
            className="st25"
            d="M362.01 167.26c.27-.64.42-1.36.42-2.15 0-2.58-1.63-4.12-4.35-4.12s-4.35 1.54-4.35 4.12c0 .73.13 1.4.35 2-2.1 1.21-3.5 3.37-3.5 5.85 0 3.79 3.29 5.9 7.34 5.9s7.34-2.11 7.34-5.9c-.01-2.37-1.29-4.46-3.25-5.7m-7.01-2.15c0-1.89 1.03-2.84 3.07-2.84s3.07.96 3.07 2.84c0 .53-.09 1.07-.28 1.57-.9-.37-1.9-.58-2.95-.58-.94 0-1.84.17-2.67.47a4.6 4.6 0 0 1-.24-1.46"
          />
          <path
            className="st23"
            d="M357.91 176.68c-2.86 0-4.79-1.57-4.79-3.91 0-2.48 2.15-4.49 4.79-4.49s4.79 2.02 4.79 4.49c0 2.34-1.92 3.91-4.79 3.91m0-7.77c-2.29 0-4.15 1.73-4.15 3.86 0 2.26 2.08 3.27 4.15 3.27 2.06 0 4.15-1.01 4.15-3.27 0-2.12-1.86-3.86-4.15-3.86"
          />
          <path
            className="st23"
            d="M356.23 171.52c-.12 0-.22.01-.3.04s-.15.06-.2.1-.1.08-.13.13c-.03.04-.06.09-.09.13s-.06.07-.09.1-.07.04-.12.04c-.08 0-.14-.02-.17-.06a.3.3 0 0 1-.05-.17c0-.15.06-.28.17-.41.03-.04.08-.08.14-.13a.7.7 0 0 1 .21-.12c.08-.04.18-.07.29-.09.11-.03.23-.04.37-.04.36 0 .65.09.85.27q.3.27.3.75c0 .06-.01.13-.02.21s-.03.16-.07.24c-.03.08-.08.17-.13.26a2 2 0 0 1-.5.51c-.09.07-.19.14-.29.21s-.21.14-.31.22q-.165.12-.33.27c.11.06.22.09.35.11q.18.03.42.03c.14 0 .26 0 .35-.01s.16-.01.21-.03c.05-.01.1-.02.13-.03s.06-.01.1-.01c.12 0 .19.06.19.17 0 .1-.04.18-.13.23q-.12.075-.3.12c-.12.03-.24.04-.36.05s-.23.01-.31.01c-.04 0-.1 0-.18-.01-.08 0-.16-.01-.25-.03a1.3 1.3 0 0 1-.27-.06c-.09-.03-.18-.06-.25-.1a.4.4 0 0 1-.18-.16.34.34 0 0 1-.07-.22c0-.12.04-.23.13-.33.09-.11.19-.21.32-.31s.26-.2.41-.31c.15-.1.28-.21.41-.32s.23-.22.32-.34.13-.24.13-.38c0-.17-.06-.3-.17-.38-.15-.11-.32-.15-.53-.15m1.71 1.31q0-.3.06-.63c.04-.21.11-.41.21-.58s.24-.32.41-.43.39-.17.66-.17c.21 0 .39.03.54.1a1.1 1.1 0 0 1 .6.6c.05.13.09.27.12.41s.04.29.05.43c0 .14.01.27.01.39 0 .23-.03.45-.08.65-.06.2-.14.36-.25.5q-.165.21-.42.33c-.17.08-.37.12-.59.12-.24 0-.44-.05-.61-.14s-.3-.22-.4-.37c-.1-.16-.18-.34-.22-.55-.07-.2-.09-.42-.09-.66m.5-.01c0 .16.01.32.04.47s.07.28.14.39c.06.11.15.2.25.27s.23.1.37.1.26-.03.37-.09.19-.14.26-.24.12-.22.16-.36c.03-.14.05-.29.05-.46 0-.12 0-.27-.01-.42q-.015-.24-.09-.45a.9.9 0 0 0-.24-.36c-.11-.1-.26-.15-.46-.15-.17 0-.3.04-.41.12s-.19.18-.25.31-.11.26-.13.42c-.04.16-.05.31-.05.45"
          />
        </g>
        <g className="st22">
          <path
            className="st23"
            d="M525.6 101.08c-2.75-3.98-5.6-7.15-8.15-9.55.3-1.04.3-2.03 0-2.87-.31-.88-.95-1.66-1.91-2.33-.76-.53-1.48-.81-2.2-.84-.85-.04-1.71.25-2.6.88-.22-.12-.42-.23-.61-.33-1.75-.88-4-.55-5.47.81-1.24 1.14-1.79 2.92-1.4 4.52.4 1.66 1.69 3.06 3.24 4.05-.01.06-.01.13-.02.19-.42 4.48-.14 8.94.19 12.72a.844.844 0 1 0 1.68-.15c-.31-3.56-.58-7.73-.23-11.92.52.21 1.04.38 1.55.5 2.51.57 4.7-.02 6-1.62.4-.49.77-1.12 1.13-1.9 2.34 2.26 4.91 5.18 7.42 8.81.27.38.79.48 1.18.21.37-.27.46-.79.2-1.18m-18.86-7.56c-.95-.75-1.63-1.65-1.84-2.54-.24-1 .12-2.16.91-2.88.34-.31.74-.54 1.17-.68.79-.26 1.66-.22 2.4.15.01 0 .01.01.02.01-1.59 1.68-2.3 3.78-2.66 5.94m7.6.55c-1.24 1.53-3.43 1.23-4.31 1.03-.6-.14-1.19-.35-1.74-.61.34-2.49 1-4.51 2.59-6.05 1.25.81 2.83 1.99 4.59 3.57-.36.89-.74 1.58-1.13 2.06m1.63-3.87c-1.34-1.17-2.57-2.1-3.63-2.82.32-.15.63-.22.91-.2.39.02.82.2 1.32.54.45.32 1.04.83 1.28 1.5.11.32.14.65.12.98"
          />
          <path
            className="st25"
            d="m511.43 105.16-7.49 1.6c-.22.05-.35.24-.33.45l1.8 23.5a4.24 4.24 0 0 0 1.68 3.06 4.24 4.24 0 0 0 3.86.63c1.81-.6 3.03-2.39 2.88-4.33l-1.88-24.52a.44.44 0 0 0-.17-.31c-.11-.08-.23-.11-.35-.08"
          />
          <path
            className="st23"
            d="m504.04 112.97 1.27 16.56 8.37-1.23-1.27-16.57z"
          />
          <path
            className="st25"
            d="m518.35 100.72 6.31-4.35c.19-.13.41-.09.55.06l15.87 17.43c.82.9 1.21 2.11 1.07 3.32s-.79 2.3-1.79 2.99c-.13.09-.26.17-.4.24-1.68.9-3.81.57-5.12-.87l-16.56-18.19a.416.416 0 0 1 .07-.63"
          />
          <path
            className="st23"
            d="m529.1 100.7 11.18 12.29-6.64 5.24-11.18-12.28z"
          />
        </g>
        <g className="st22">
          <path
            className="st23"
            d="M126.9 161.76H75.45c-1.35 0-2.45-1.1-2.45-2.45v-.82c0-1.35 1.1-2.45 2.45-2.45h51.45c1.35 0 2.45 1.1 2.45 2.45v.82c0 1.35-1.09 2.45-2.45 2.45"
          />
          <path
            className="st25"
            d="M87.7 175.64h-2.45c-1.35 0-2.45-1.1-2.45-2.45v-29.4c0-1.35 1.1-2.45 2.45-2.45h2.45c1.35 0 2.45 1.1 2.45 2.45v29.4c0 1.36-1.1 2.45-2.45 2.45m-6.91-5.71H79.1c-.93 0-1.69-.76-1.69-1.69v-20.3c0-.93.76-1.69 1.69-1.69h1.69c.93 0 1.69.76 1.69 1.69v20.3c0 .93-.76 1.69-1.69 1.69m34.18-28.59h2.45c1.35 0 2.45 1.1 2.45 2.45v29.4c0 1.35-1.1 2.45-2.45 2.45h-2.45c-1.35 0-2.45-1.1-2.45-2.45v-29.4c0-1.35 1.1-2.45 2.45-2.45m6.92 5.72h1.69c.93 0 1.69.76 1.69 1.69v20.3c0 .93-.76 1.69-1.69 1.69h-1.69c-.93 0-1.69-.76-1.69-1.69v-20.3c-.01-.93.75-1.69 1.69-1.69m-29.29 8.98h17.97v5.72H92.6z"
          />
        </g>
        <circle
          cx={101.34}
          cy={60.3}
          r={11.19}
          style={{
            opacity: 0.36,
            fill: "none",
            stroke: "#fff200",
            strokeWidth: 1.7178,
            strokeMiterlimit: 10,
          }}
        />
        <circle
          cx={242.49}
          cy={154.33}
          r={7.43}
          style={{
            opacity: 0.36,
            fill: "none",
            stroke: "#ff3b3b",
            strokeWidth: 1.1411,
            strokeMiterlimit: 10,
          }}
        />
      </g>
    </switch>
  </svg>
);
export default SVGComponent;
